export const selectBecomeSitter = state => state.becomeSitter
export const selectAddresss=state=>state.userDetails.address
export const selectservice=state=>state.userDetails.service
export const selectpets=state=>state.userDetails.pets